import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Avatar,
  Badge,
} from "@mui/material";
import MoveToInboxOutlinedIcon from "@mui/icons-material/MoveToInboxOutlined";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import ListOutlinedIcon from "@mui/icons-material/ListOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import NewReleasesOutlinedIcon from "@mui/icons-material/NewReleasesOutlined";
import {
  cardHover,
  cardOutline,
  fonts,
  headingFonts,
} from "../../Styles/Styles";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

const dashboardItems = [
  {
    title: "Inbox",
    description: "Check and reply to your messages",
    icon: <MoveToInboxOutlinedIcon fontSize="large" />,
    path: "/inbox",
  },
  {
    title: "Notifications",
    description: "Stay updated with alerts and activity",
    icon: <NotificationsNoneOutlinedIcon fontSize="large" />,
    path: "/notifications",
  },
  {
    title: "My Ads",
    description: "Manage your listed ads and updates",
    icon: <ListOutlinedIcon fontSize="large" />,
    path: "/my-ads",
  },
  {
    title: "My Offers",
    description: "View and manage offers on your ads",
    icon: <LocalOfferOutlinedIcon fontSize="large" />,
    path: "/offers",
  },
  {
    title: "My Favorites",
    description: "Access ads you've favorited",
    icon: <FavoriteBorderOutlinedIcon fontSize="large" />,
    path: "/my-favorites",
  },
  {
    title: "User Profile",
    description: "Edit your personal account details",
    icon: <AccountCircleOutlinedIcon fontSize="large" />,
    path: "/profile",
  },
  {
    title: "Business Profile",
    description: "Manage your business information",
    icon: <BusinessOutlinedIcon fontSize="large" />,
    path: "/my-services",
  },
  {
    title: "What's New",
    description: "Discover the latest features and news",
    icon: <NewReleasesOutlinedIcon fontSize="large" />,
    path: "/whats-new",
  },
];

const DashboardItems = ({ unreadNotifications, unreadMessages }) => {
  const navigate = useNavigate();

  return (
    <Grid container spacing={3}>
      {dashboardItems.map((item, index) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
          <Card
            elevation={1}
            onClick={() => navigate(item.path)}
            sx={{
              ...cardOutline,
              ...cardHover,
              height: "100%",
              cursor: "pointer",
            }}
          >
            <CardContent
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                py: 5,
              }}
            >
              <Box sx={{ mb: 2, color: "var(--primary-color)" }}>
                {item.title === "Notifications" ? (
                  <Badge
                    badgeContent={unreadNotifications}
                    color="error"
                    sx={{ cursor: "pointer" }}
                  >
                    {item.icon}
                  </Badge>
                ) : item.title === "Inbox" ? (
                  <Badge
                    badgeContent={unreadMessages}
                    color="error"
                    sx={{ cursor: "pointer" }}
                  >
                    {item.icon}
                  </Badge>
                ) : (
                  item.icon
                )}
              </Box>

              <Typography variant="subtitle1" sx={{ ...headingFonts }}>
                {item.title}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                mt={0.5}
                sx={{ ...fonts }}
              >
                {item.description}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default DashboardItems;
